 import Rom from "../../img/Carousel/dong-gia-1k-ve-khi-mua-ve-qua-tix-16011908558560.jpg";
 import BoGia from '../../img/Carousel/bo-gia-16146819941008.png';
 import AmQuy from '../../img/Carousel/an-quy-16170973985377.png';
 const data = [
    {
        banner:Rom,
        trailler:"https://www.youtube.com/embed/XRm1P7oGpMQ"
    },
    {
        banner:BoGia,
        trailler:"https://www.youtube.com/embed/jluSu8Rw6YE"
    },
    {
        banner:AmQuy,
        trailler:"https://www.youtube.com/embed/f1Nv2O7VJuo"
    }
] 
export default data;